import { useEffect, useRef, useState } from "react";

const useVisibilityOnScroll = () => {
  const [isVisible, setIsVisible] = useState(false);
  const containerRef = useRef(null);

  const checkVisibility = () => {
    if (!containerRef.current) {
      return;
    }

    const rect = containerRef.current.getBoundingClientRect();
    const halfVisible = rect.top + rect.height / 2 < window.innerHeight;
    const notTooLow = rect.bottom - rect.height / 2 > 0;

    if (halfVisible && notTooLow) {
      setIsVisible(true);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', checkVisibility, { passive: true });
    checkVisibility(); // Initial check

    return () => {
      window.removeEventListener('scroll', checkVisibility);
    };
  }, []);

  return [containerRef, isVisible];
};

export default useVisibilityOnScroll;
